import { GST, INCLUSIVE } from './constants';

export const calculateGstAdjustedAmount = (amount, gstInclusive) => {
  if (!amount || !gstInclusive) return null;

  return gstInclusive === INCLUSIVE ? Number(amount) * GST : Number(amount);
};
